// extracted by mini-css-extract-plugin
module.exports = {"container":"VTExi","switch":"t3TS0"};